import React, { useEffect, useState } from "react";
import ContentContainer from "../../components/ContentContainer";
import { Typography, Layout, Result, Button, Card, Image } from "antd";
import PublicFooter from "../../components/public/Footer";
import { ToolOutlined } from "@ant-design/icons";
import { closeWindow } from "../../utils";
import axios from "axios";
import moment from "moment";

moment.locale("fr");

const AnonymousVisit = () => {
  const { Title } = Typography;

  const [data, setData] = useState(undefined);
  const [urlLogo, setUrlLogo] = useState(undefined);
  const [isFound, setIsFound] = useState(false);
  const [promoter, setPromoter] = useState(undefined);
  const [isValid, setIsValid] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [project, setProject] = useState(undefined);
  const [isCustomLogo, setIsCustomLogo] = useState(undefined);

  const fetchVisit = async (uuid) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_VR_API_URL + "/vv/" + uuid.toString()
      );

      // console.log(`res = ${JSON.stringify(res)}`);
      const res2 = await axios.get(
        process.env.REACT_APP_VR_API_URL + "/promoters/" + res.data.promoter
      );
      // TO DO: Ne prend pas en compte la date de debut, or elle est
      // demandee en front
      const valid = moment(res.data.endDate) > new Date();
      setIsValid(valid);
      setPromoter(res2.data);

      let fetchedProject = await axios.get(
        `${
          process.env.REACT_APP_API_URL
        }/program-logo-from-name?name=${encodeURIComponent(
          res2.data.internalName
        )}`
      );
      setProject(fetchedProject.data);

      try {
        await axios.get(
          process.env.REACT_APP_VR_API_URL +
            "/promoter/" +
            res.data.promoter +
            "/logo"
        );
        setIsCustomLogo(true);
      } catch (e) {
        // console.log("NO LOGO");
        setIsCustomLogo(false);
      }
      setUrlLogo(
        process.env.REACT_APP_VR_API_URL +
          "/promoter/" +
          res.data.promoter +
          "/logo"
      );

      // console.log(`promoter ---> ${res2.data.internalName}`);
      setData(res.data);
      setIsFound(true);
      // console.log(`res.DATA ===> ${JSON.stringify(res.data)}`);
      // console.log(`LOGO OK = ${JSON.stringify(res2.data.logo)}`);

      await fetchAnonymousUserInfo(res.data, res2.data.internalName, uuid);
    } catch (e) {
      console.log("first error");
      console.log(e);

      setIsFound(false);
    }
  };

  const countVisit = async (uuid) => {
    try {
      await axios.post(
        process.env.REACT_APP_VR_API_URL +
          "/vv/" +
          uuid.toString() +
          "/increment",
        {}
      );
    } catch (e) {
      console.log("Erreur increment counter : " + e);
    }
  };

  const fetchAnonymousUserInfo = async (dt, promoterInternalName, uuid) => {
    // try {
    let url =
      "https://geolocation-db.com/json/" +
      process.env.REACT_APP_GEOLOCALISATION_DATA_API;

    //   const response = await axios.get(url);
    //   console.log(`ZATAZ`);
    //   console.log("RES.DATA");
    //   console.log(response);
    // } catch (e) {
    //   console.log(
    //     `There has been an error while fetching url : ${
    //       "https://geolocation-db.com/json/" +
    //       process.env.REACT_APP_GEOLOCALISATION_DATA_API
    //     }`
    //   );
    // }

    fetch(url)
      .then((response) => response.json())
      .then((dataGeo) => {
        axios.post(process.env.REACT_APP_VR_API_URL + "/vv/logs", {
          uuid,
          name: dt.name,
          promoter: promoterInternalName,
          pointer: dt.pointer,
          payload: dt.payload,
          startDate: dt.startDate,
          endDate: dt.endDate,
          email: dt.email,
          vues: {
            date: moment(),
            country_code: dataGeo.country_code,
            country_name: dataGeo.country_name,
            city: dataGeo.city,
            postal: dataGeo.postal,
            latitude: dataGeo.latitude,
            longitude: dataGeo.longitude,
            IPv4: dataGeo.IPv4,
            state: dataGeo.state,
          },
        });
      })
      .catch((err) => {
        console.log(`ERR -> : ${JSON.stringify(err)}`);
        console.log(err);
      });
  };

  useEffect(() => {
    const newFunc = async (uuid) => {
      await fetchVisit(uuid);
      setHasLoaded(true);
    };

    const uri = window.location.pathname;
    const uuid = uri.replace("/immersion/", "");

    if (uuid !== "") {
      newFunc(uuid);
      countVisit(uuid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const CustomContent = ({ isValid, isFound }) => {
    if (isValid && isFound) {
      return (
        <div>
          {isCustomLogo ? (
            <Card hoverable style={{ width: 300, border: "none" }}>
              <img src={urlLogo} alt="promoteur" />
            </Card>
          ) : (
            <Card hoverable style={{ width: 300, border: "none" }}>
              <Image
                preview={false}
                src={
                  project.avatar === undefined
                    ? "error"
                    : "data:image/jpeg;base64," +
                      btoa(
                        [].reduce.call(
                          new Uint8Array(project.avatar.data),
                          function (p, c) {
                            return p + String.fromCharCode(c);
                          },
                          ""
                        )
                      )
                }
                fallback="data:image/png;base64,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"
              />
            </Card>
          )}

          <br />

          <br />
          <Title level={2}>Bonjour {data.name}</Title>
          <Title level={3}>{promoter.firstParagraph}</Title>
          <p>{promoter.secondParagraph}</p>
          <p>{promoter.thirdParagraph}</p>
          <p>
            <i>
              Attention ce lien est valable jusqu'au{" "}
              {moment(data.endDate).format("Do MMMM YYYY")}.
            </i>
          </p>
          <br />
          <div className="matterport-showcase">
            {!data.payload.includes(";") ? (
              <iframe
                title="Showcase"
                width="853"
                height="480"
                src={data.payload}
                frameBorder="0"
                allowFullScreen
                allow="xr-spatial-tracking"
              ></iframe>
            ) : (
              data.payload.split(";").map((_, idx) => (
                <div key={idx}>
                  <iframe
                    title={"Showcase-" + idx}
                    width="853"
                    height="480"
                    src={_.trim()}
                    frameBorder="0"
                    allowFullScreen
                    allow="xr-spatial-tracking"
                  ></iframe>
                  <br />
                  <br />
                </div>
              ))
            )}
          </div>
        </div>
      );
    } else if (!isValid && isFound) {
      return (
        <div>
          {isFound && (
            <div>
              <Card hoverable style={{ width: 300, border: "none" }}>
                <img src={urlLogo} alt="promoteur" />
              </Card>

              <br />
              <br />
              <Title level={2}>Bonjour {data.name}</Title>
              <p>
                <i>
                  Votre visite est expirée. Si besoin, rapprochez-vous de votre
                  promoteur pour réactiver le lien.
                </i>
              </p>
              <br />
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <Result
            icon={<ToolOutlined />}
            title="Visite non trouvée"
            extra={
              <Button type="primary" onClick={closeWindow}>
                Quitter
              </Button>
            }
          />
        </div>
      );
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout className="site-layout">
        <ContentContainer>
          <div>
            <br />
            <center>
              {hasLoaded && (
                <CustomContent isValid={isValid} isFound={isFound} />
              )}
            </center>
            <br />
          </div>
        </ContentContainer>
        <PublicFooter />
      </Layout>
    </Layout>
  );
};

export default AnonymousVisit;
